const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Validates translation hook parameters.
 * Throws an Error with a user-friendly message on invalid input.
 */
export function validateTranslationParams(startDate, endDate, languages) {
  if (!languages || languages.length === 0) {
    throw Object.assign(new Error('Please select at least one language.'), { status: 400 });
  }
  if (!DATE_RE.test(startDate) || !DATE_RE.test(endDate)) {
    throw Object.assign(new Error('Invalid date format. Expected YYYY-MM-DD.'), { status: 400 });
  }
  if (startDate > endDate) {
    throw Object.assign(new Error('Start date must not be after end date.'), { status: 400 });
  }
}

/**
 * Extracts a user-friendly message from an API error response.
 */
export function apiErrorMessage(err) {
  const serverDetail = err?.response?.data?.detail;
  if (serverDetail) return typeof serverDetail === 'string' ? serverDetail : JSON.stringify(serverDetail);
  const status = err?.response?.status;
  if (status >= 400 && status < 500) return `Request error (${status}). Please check your inputs.`;
  if (status >= 500) return `Server error (${status}). Please try again later.`;
  return 'Failed to load data. Please try again.';
}
